import { useAuth } from '@/auth/AuthContext'
import AlterarSenhaModal from '@/components/AlterarSenhaModal'
import { Dropdown, DropdownItem } from '@/components/ui/dropdown'
import { cn } from '@/lib/utils'
import { ChevronDown, KeyRound, LogOut, UserRound } from 'lucide-react'
import { useState } from 'react'
import { FcApproval, FcDocument, FcSettings } from "react-icons/fc"
import { NavLink, Outlet } from 'react-router-dom'

const nav = [
  { to: '/contrato', label: 'Contratos', icon: FcDocument },
  { to: '/nf', label: 'Notas Fiscais', icon: FcApproval },
  { to: '/cadastro', label: 'Cadastros', icon: FcSettings  },
]

export default function Layout() {
  const { user, logout } = useAuth()
  const [senhaOpen, setSenhaOpen] = useState(false)
  const userData = user?.user || user?.data || user
  const userName =
    userData?.nome?.trim() ||
    userData?.usuarioNome?.trim() ||
    userData?.name?.trim() ||
    userData?.email?.split('@')[0] ||
    'Usuário'

  return (
    <div className="h-screen flex flex-col bg-background text-foreground">
      <header className="h-16 shrink-0 border-b border-border bg-card grid grid-cols-3 items-center px-6">
        {/* Esquerda: logomarca */}
        <div className="flex items-center">
          <span className="font-bold text-xl tracking-tight text-primary">
            <img src="/precisa.png" alt="Logo" className="h-5 w-auto" />
          </span>
        </div>

        {/* Centro: menu */}
        <nav className="flex items-center justify-center gap-1">
          {nav.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2 px-4 py-2 rounded-md text-sm font-semibold transition-colors',
                  isActive
                    ? 'bg-accent text-accent-foreground'
                    : 'text-muted-foreground hover:bg-accent/60 hover:text-foreground'
                )
              }
            >
              <Icon className="h-5.5 w-5.5" />
              {label}
            </NavLink>
          ))}
        </nav>

        {/* Direita: usuário logado (dropdown com alterar senha / sair) */}
        <div className="flex min-w-0 items-center justify-end">
          <Dropdown
            trigger={
              <button
                type="button"
                aria-label={`Abrir menu do usuário ${userName}`}
                aria-haspopup="menu"
                title={userName}
                className="flex max-w-full cursor-pointer items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-foreground transition-colors hover:bg-accent/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <UserRound className="h-4 w-4" aria-hidden="true" />
                </span>
                <span className="max-w-[180px] truncate">{userName}</span>
                <ChevronDown className="h-4 w-4 shrink-0" />
              </button>
            }
          >
            <div className="border-b border-border px-3 py-2">
              <p className="truncate text-sm font-medium text-foreground">{userName}</p>
              {userData?.email && <p className="truncate text-xs text-muted-foreground">{userData.email}</p>}
            </div>
            <DropdownItem onClick={() => setSenhaOpen(true)}>
              <KeyRound className="h-4 w-4 text-muted-foreground" /> Alterar senha
            </DropdownItem>
            <DropdownItem className="text-destructive hover:bg-destructive/10" onClick={logout}>
              <LogOut className="h-4 w-4" /> Sair
            </DropdownItem>
          </Dropdown>
        </div>
      </header>

      <main className="flex-1 min-h-0 overflow-auto">
        <Outlet />
      </main>

      <AlterarSenhaModal open={senhaOpen} onClose={() => setSenhaOpen(false)} />
    </div>
  )
}
